export const Accordion = (props) => {
  return <div>{props.children}</div>;
};
